

exports.__esModule = true;
exports.$SidebarCurrencyConversionRoute = undefined;

var _squid = require('squid');

require('./directive');

var $SidebarCurrencyConversionRoute = exports.$SidebarCurrencyConversionRoute = _squid.$ComponentRoute.extend('$SidebarCurrencyConversionRoute', {
    path: 'currencyConversion',
    directive: 'xo-sidebar-currency-conversion-page',
    titleContent: 'asideHeader.currencyConversion',
    trackingData: {
        fptiState: 'currency_conversion',
        templateName: 'tray/currencyOptions.dust',
        pageGoal: 'Currency Conversion',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-currency-options',
                'pagename2': '%::fullpage-currency-options::hermes:',
                'version': ':%:'
                // More page qualifiers come here...
            } }
    },
    children: []
});

angular.value("$SidebarCurrencyConversionRoute", $SidebarCurrencyConversionRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar-currency-conversion/route.js
// module id = ./pages/xo-sidebar-currency-conversion/route.js
// module chunks = 0